import { useState } from 'react'
import { Box } from '@mui/material'
import { TimeHHMM } from '../../types/models'
import { ClockPicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { DateTime } from 'luxon'
import { PickerOnChangeFn } from '@mui/x-date-pickers/internals/hooks/useViews'

export interface TimeEditProps {
  value: TimeHHMM
  onChange: (value: TimeHHMM, done: boolean) => void
}

export function TimeEdit(props: TimeEditProps): JSX.Element {
  const { value, onChange } = props
  const date = DateTime.fromISO(`2000-01-01T${value}:00.000`)
  const [editing, setEditing] = useState(false)

  const onTimeChange: PickerOnChangeFn<DateTime> = (newDate: DateTime | null, mode) => {
    const done = mode === 'finish'
    onChange(newDate?.toFormat('HH:mm') as TimeHHMM, done)
    setEditing(!done)
  }

  if (!editing) {
    return <Box onClick={() => setEditing(true)} sx={{
      mx: 10,
      textAlign: 'center',
      fontSize: '1rem',
      fontWeight: 400,
      height: '2.5rem',
      letterSpacing: '0.5rem',
      borderRadius: '0.375rem',
      backgroundColor: 'rgba(255,255,255,0.1)',
      display: 'grid',
      gridTemplateColumns: 'auto',
      alignItems: 'center',
    }}>
      {value}
    </Box>
  }

  return <Box>
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <ClockPicker
        ampm={false}
        date={date}
        minutesStep={5}
        onChange={onTimeChange}
      />
    </LocalizationProvider>
  </Box>
}
